export default __webpack_public_path__ + "static/media/6-2.12154da1.png";